<template>
  <section
    class="section section-primary is-small animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->
      <div class="content-wrapper animated preFadeInUp fadeInUp">
        <div class="section-title-wrapper has-text-centered mb-20">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-credit-card"> </i>
          </div>
          <div>
            <h2
              class="clean-section-title has-text-white has-text-weight-bold is-paddingless"
            >
              خدمات الهاتف النقال
            </h2>
            <h3
              class="subtitle is-5 pt-10 pb-10 has-text-white has-text-weight-bold"
            >
              تمكنك من الاشتراك في خدمة الصحارى موبايل (خدمات مصرف الصحارى عبر
              الهاتف المحمول).
            </h3>
          </div>
        </div>
        <h2></h2>
        <div class="columns is-vcentered s">
          <div class="column">
            <div
              class="flex-card icon-card-hover second-card light-bordered padding-20"
              @click="makeOtpRequest('الاشتراك في الصحارى موبايل ', 14)"
            >
              <h3 class="card-title has-text-link">
                طلب الاشتراك في الصحارى موبايل
              </h3>
              <p class="card-description">
                يمكنك التقدم بطلب الإشتراك بالخدمة ، والتي من خلالها ستصل إليك
                إشعارات عن كل العمليات التي تتم على حسابك ، كما يمكنك الاستعلام
                عن رصيدك وحركة حسابك ، بالإضافة إلى إمكانية شراء كروت الدفع
                المسبق لكلا من شركات (ليبيانا ، المدار ، ليبيا للاتصالات
                والتقنية ) .
              </p>
            </div>
          </div>
          <div class="column">
            <div
              class="flex-card icon-card-hover second-card light-bordered padding-20"
              @click="makeRequest('إلغاء الاشتراك في الصحارى موبايل ', 15)"
            >
              <h3 class="card-title has-text-link is-clean">
                طلب إلغاء الاشتراك في الصحارى موبايل
              </h3>
              <p class="card-description">
                بناء على إشتراكك مسبقا بخدمة ( الصحارى موبايل ) الخاصة بخدمات
                الهاتف النقال ، ولسببٍ ما قد ترغب في إلغاء الإشتراك ، لذا فإنه
                يمكنك من هنا إلغاء الإشتراك بالخدمة ، آملين منك ذكر السبب ليتسنى
                لنا النظر في ذلك .
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
      >
        <router-link to="/portal">
          <a class="button is-dark btn-align modal-dismiss is-bold is-medium">
            <b>عودة للرئيسية</b>
          </a>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

export default {
  name: "mobile",

  data() {
    return {
      customerdate: null,
      customertime: null,
      url: "mobi/newRequest",
      requestInfo: {
        ServicAction_Id: null,
        Customer_Id: 1,
        BranchId: null,
      },
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.logItIn();
          return;
        }
      });
    },
    makeOtpRequest(actionstring, action, url) {
      this.$dialog.confirm({
        message: "هل انت متأكد من طلب " + actionstring,
        cancelText: "لا",
        confirmText: "نعم",
        type: "is-success",
        onConfirm: () =>
          this.$router.push({
            name: "Servicerequestwithotp",
            params: {
              requeststring: actionstring,
              requestid: action,
              requesturl: this.url,
            },
          }),
      });
    },
    makeRequest(actionstring, action, url) {
      this.$dialog.confirm({
        message: "هل انت متأكد من طلب " + actionstring,
        cancelText: "لا",
        confirmText: "نعم",
        type: "is-success",
        onConfirm: () =>
          this.$router.push({
            name: "servicerequest",
            params: {
              requeststring: actionstring,
              requestid: action,
              requesturl: this.url,
            },
          }),
      });
    },
  },
};
</script>
